import { useQuery } from 'react-query';
import { POST } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';
import isEqual from 'lodash/isEqual';
import { userDataShowQuestion, userDataHideQuestion } from 'store/userData';
import { useDispatch } from 'react-redux';
import { questionMaper } from 'components/Question/utils';

export function ValidateQuestion({ lngCode,clientStateData: currentClientStateData, useMock}) {
  const dispatch = useDispatch();

  const baseApi = `${lngCode}`;
  const clientStateDataUpdate = useClientStateDataUpdate();
  return {
    useQuestionQuery ( customerGUID, journeyGUID, questionAnswerDict, questionType, jsonData, propertyId,  serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds,selectedSlot,selectedDate, isUserDataLoaded, userData) {
      return useQuery(['active-query', 'questions', propertyId],
      () => validateQuestions(customerGUID, journeyGUID, questionAnswerDict, questionType, jsonData, propertyId, serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds,selectedSlot,selectedDate,userData),
      { enabled: isUserDataLoaded }
    );
  },
}
  function getClientStateData( customerGUID, journeyGUID, questionAnswerDict, serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds,selectedSlot,selectedDate) {
    const clientStateData = {}
    if (customerGUID) clientStateData.customerGUID = customerGUID
    if (journeyGUID) clientStateData.journeyGUID = journeyGUID
    if (serviceTypeId) clientStateData.serviceTypeId = serviceTypeId
    if (serviceId) clientStateData.serviceId = serviceId
    if (unitId) clientStateData.unitId = unitId
    if (appointmentTypeId) clientStateData.appointmentTypeId = appointmentTypeId
    if (questionAnswerDict) clientStateData.questionAnswerDict = questionAnswerDict
    if (calendarIds) clientStateData.calendarIds = calendarIds
    if (selectedSlot) clientStateData.selectedSlot = selectedSlot
    if (selectedDate) clientStateData.selectedDate = selectedDate
    return clientStateData;
  }

  
    async function validateQuestions( customerGUID, journeyGUID, questionAnswerDict, questionType, jsonData, propertyId ,serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds,selectedSlot,selectedDate, userData, dont_show_question) {
    
    if(useMock){
      return Promise.resolve(() =>
      {
        return {
          showQuestion: true
        }
      })
    }

    const params = {
      clientStateData: getClientStateData(customerGUID,journeyGUID, questionAnswerDict, serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds,selectedSlot,selectedDate,)
    };

    if (lngCode) params.lngCode = lngCode;
    if (questionType) params.propertyType  = questionType;
    if (propertyId) params.propertyId  = propertyId;
    if (journeyGUID) params.journeyGUID = journeyGUID;

    const response = await POST(`${baseApi}/questions/validatequestion`,  params )
    if (!!response.clientStateData && !isEqual(response.clientStateData, currentClientStateData)) {
        clientStateDataUpdate(response.clientStateData);
    }

    setTimeout(() => {
      const showQuestion = !!response ? response?.showQuestion : 'BUG'
      const parsedData = !!response?.jsonData ? questionMaper(JSON.parse(response.jsonData)) : null;
      const hasCurrentQuestionToNotShow = userData?.dont_show_question ? !!Object.keys(userData?.dont_show_question)?.includes(parsedData?.questionKey): false
      
      if (!!parsedData && showQuestion === true && hasCurrentQuestionToNotShow ) {
        dispatch(userDataShowQuestion(parsedData?.questionKey));
      } else if(!!parsedData && showQuestion === false && !hasCurrentQuestionToNotShow  ) {
        dispatch(userDataHideQuestion({[parsedData.questionKey]: propertyId}));
      }
    })

    return response
  }
}
